import { render, staticRenderFns } from "./discount-list.vue?vue&type=template&id=0f85d19a&scoped=true"
import script from "./discount-list.vue?vue&type=script&lang=js"
export * from "./discount-list.vue?vue&type=script&lang=js"
import style0 from "./discount-list.vue?vue&type=style&index=0&id=0f85d19a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f85d19a",
  null
  
)

export default component.exports